export const url = {
  get: parameter => (parameter ? new URL(window.location.href).searchParams.get(parameter) || undefined : undefined),
  has: parameter => url.get(parameter) !== undefined,
};
